import React from 'react';

export const Marquee = () => {
  return (
    <div className="bg-[#FF8FAB] text-white py-3 overflow-hidden whitespace-nowrap">
      <div className="inline-flex animate-[marquee_20s_linear_infinite] gap-0">
        <span className="font-extrabold text-sm px-7 tracking-wide">✿ Fidgets</span>
        <span className="font-extrabold text-sm px-7 tracking-wide">✿ Squishes</span>
        <span className="font-extrabold text-sm px-7 tracking-wide">✿ Novelty Toys</span>
        <span className="font-extrabold text-sm px-7 tracking-wide">✿ Kawaii Gifts</span>
        <span className="font-extrabold text-sm px-7 tracking-wide">✿ Free Shipping Over $49.99</span>
        <span className="font-extrabold text-sm px-7 tracking-wide">✿ Kids Love Us</span>
        <span className="font-extrabold text-sm px-7 tracking-wide">✿ Fidgets</span>
        <span className="font-extrabold text-sm px-7 tracking-wide">✿ Squishes</span>
        <span className="font-extrabold text-sm px-7 tracking-wide">✿ Novelty Toys</span>
        <span className="font-extrabold text-sm px-7 tracking-wide">✿ Kawaii Gifts</span>
        <span className="font-extrabold text-sm px-7 tracking-wide">✿ Free Shipping Over $49.99</span>
        <span className="font-extrabold text-sm px-7 tracking-wide">✿ Kids Love Us</span>
      </div>
    </div>
  );
};
